/*
 * サブシステム名：
 * 機能名：配車表入力
 * 表示項目カスタマイズ(アズレック)
 */
import D2PLMD1010 from '@/views/PLM/D2PLMD1010.js'
import date from '@/ddv2.library/date'
import indexeddb from '@/ddv2.library/indexeddb'
import filter from '@/rahmen/utils/filters'

export default {
  extends: D2PLMD1010,
  name: 'HaishaMeisaiListEditCustomForAzc',
  data: () => ({
    unkoYmdMultiFlg: true,
    conditionDetails: [
      { key: 'unkoYmdFromTo', name: '運行日', value: 'unkoYmdFromTo', delete: false },
      { key: 'haishahyoCd', name: '配車表', value: 'haishahyoNm', delete: true },
      { key: 'haishaEigyoshoId', name: '配車営業所', value: 'haishaEigyoshoNm', delete: true },
      { key: 'sharyoId', name: '車両', value: 'sharyoNm', delete: true },
      { key: 'jininId1', name: '乗務員', value: 'jininNm1', delete: true },
      { key: 'tokuisakiId', name: '得意先', value: 'tokuisakiNm', delete: true }
    ],
    headerType: 'D2PLMD1011'
  }),
  computed: {
  },
  methods: {
    /**
     * スプレッドシート変更後イベント
     * @param {*} rowData
     * @param {*} cell
     * @param {*} x
     * @param {*} y
     * @param {*} newValue
     * @param {*} oldValue
     */
    changeAfter (rowData, cell, x, y, newValue, oldValue) {
      // console.log('c', rowData, cell, x, y, newValue, oldValue)

      if (Number(x) === this.computedColNumList.haishaKbnNm) {
        console.log('change After :', this.computedColNumList.jidoshaHyojiNm, this.computedColNumList.hacchusakiNm)
        // 配車先毎入力制御
        if (newValue === '自社') {
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.jidoshaHyojiNm, y, false)
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.hacchusakiNm, y, true)
        } else if (newValue === '傭車') {
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.jidoshaHyojiNm, y, true)
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.hacchusakiNm, y, false)
        }
      }
      // 主たる乗務員をセットする
      if (Number(x) === this.computedColNumList.jidoshaHyojiNm) {
        const target = filter.dateFormatter(new Date())

        const sharyoInfo = this.sharyoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((elem) => {
          return elem.kaishaCd === this.currentKaishaCode && elem.jidoshaHyojiNm === newValue && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })

        if (sharyoInfo.length > 0) {
          const targetJomuinCd = sharyoInfo[0].jomuinCd
          if (![undefined, null, ''].includes(targetJomuinCd)) {
            const targetJomuin = this.eigyoshoJininList.map((elem) => {
              elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
              elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
              return elem
            }).filter((elem) => {
              return elem.kaishaCd === this.currentKaishaCode && elem.jininCd === targetJomuinCd && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
            })
            if (targetJomuin.length > 0) {
              const cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.jininNm1, y)
              this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, targetJomuin[0].jininNmSei, true)
            }
          }
        }
      }
      /*
        請求金額自動計算
        */
      if (this.computedColNumList.hinmokuKihonUnchin || this.computedColNumList.meisaiKihonUnchin) {
        const t = this.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === this.currentKaishaCode
        }).find(x => x.codeNm === this.rows[y].unchinKeisanKbnNm)
        const tUnchinKeisanKbn = t ? t.code : '01'
        const hinmoku = this.computedColNumList.hinmokuKihonUnchin ? 'hinmoku' : ''

        if (Number(x) === this.computedColNumList.juchuSuryo) {
          this.calcKihonUnchinByQuantity(Number(y), hinmoku)
        }
        if (Number(x) === this.computedColNumList.juchuJuryo) {
          this.calcKihonUnchinByWeight(Number(y), hinmoku)
        }
        if (Number(x) === this.computedColNumList.unchinKeisanKbnNm) {
          if (tUnchinKeisanKbn === '01') {
            this.calcKihonUnchinByQuantity(Number(y), hinmoku)
          } else if (tUnchinKeisanKbn === '02') {
            this.calcKihonUnchinByWeight(Number(y), hinmoku)
          } else {
            this.calcKihonUnchinByCharter(Number(y), hinmoku)
          }
        }
        if (Number(x) === this.computedColNumList.tanka) {
          if (tUnchinKeisanKbn === '01') {
            this.calcKihonUnchinByQuantity(Number(y), hinmoku)
          } else if (tUnchinKeisanKbn === '02') {
            this.calcKihonUnchinByWeight(Number(y), hinmoku)
          } else {
            this.calcKihonUnchinByCharter(Number(y), hinmoku)
          }
        }
      }
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        sagyoYoteiYmdFrom: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        sagyoYoteiYmdTo: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        haishaEigyoshoId: this.eigyoshoReadOnly ? indexeddb.getRecordByCd(this.currentKaishaCode, this.filteredEigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).id : null,
        haishahyoCd: null,
        eigyoshoId: null,
        tokuisakiId: null
      }
      this.conditions = {
        ...initConditions,
        // 表示用
        unkoYmdFromTo: initConditions.sagyoYoteiYmdFrom + '～' + initConditions.sagyoYoteiYmdTo,
        haishahyoNm: null,
        haishaEigyoshoNm: null,
        sharyoNm: null,
        jomuinNm: null
      }
      this.isAfterSearch = false
      this.haishaChohyoSbt = '0'
      this.nohinshoChohyoSbt = '99'
      this.searchText = ''
      this.rows = []
      this.page = 1
    }
  }
}
